
/* eslint-disable i18n/no-chinese-character */
import jsCookie from 'js-cookie';
import { socketHOST as HOST } from '@/utils/env';
import i18n from '@/locales/init';

// Websocker message 错误码
// 4000 请求AI服务错误
// 4001 参数错误

export const getErrorMsg = (code: number, errorMsg?: string) => {
  if (code === 4000) {
    return i18n.t('common.dauyan_network_not_online');
  }
  if (code === 4001) {
    if (errorMsg?.includes('Data too long')) {
      return i18n.t('common.dauyan_network_ask_again');
    }
    return i18n.t('common.dauyan_network_socket_cannot_answer');
  }
  if (code === 3001) {
    return errorMsg || i18n.t('common.dauyan_network_permission_denied');
  }
  return i18n.t('common.dauyan_network_error_retry_later');
};

export const createWebsocketInstance = (
  url: string,
  config?: {
    open?: (event: Event, instance: WebSocket) => any;
    close?: (event: CloseEvent, instance: WebSocket) => any;
    error?: (event: Event, instance: WebSocket | null, opened: boolean) => any;
    message?: (event: MessageEvent, instance: WebSocket) => any;
  },
): WebSocket | null => {

  const token = jsCookie.get('token');
  const lang = jsCookie.get('lang');
  const uri = `${HOST}${url}?lang=${lang}&Authorization=${token}`;
  let socket: WebSocket | null = null;

  let opened = false;

  try {
    socket = new WebSocket(uri);

    // 创建连接
    socket.addEventListener('open', (event: Event) => {
      console.info('🕹️ [WebSocket] 已经建立连接', event);
      opened = true;
      config?.open && event.target && config.open(event, socket!);
    });

    // 关闭连接
    socket.addEventListener('close', (event: CloseEvent) => {
      console.info('💥 [WebSocket] 关闭连接', event);
      config?.close && event.target && config.close(event, socket!);
    });

    // 报错
    socket.addEventListener('error', (event: Event) => {
      console.info('💥 [WebSocket] 报错', event);
      if (!opened && !token) {
        console.error('当前用户无权限');
      }
      config?.error && config.error(event, socket, opened);
    });

    // 接收消息
    socket.addEventListener('message', (event: MessageEvent) => {
      const json = JSON.parse(event.data);
      console.log('📩 [WebSocket] 接收到消息:', json.code, json.data);
      config?.message && config.message(event, socket!);

    });
    return socket;
  } catch (e) {
    console.log(e);
    config?.error && config.error(e as any, socket, opened);
    return null;
  }
};